import {AxiosError} from 'axios'
import {showMessage} from 'exsportia-components'

// import {useNavigate} from 'react-router-dom'
import {API} from '../../networking/http'
import {useLocale} from '../../utils/i18n'
import {QueryOptions, UseQueryOptions} from '../helpers/types'
import {Venue} from './types'

export type GetVenueParams = {
  id?: string
}
export type GetVenueQueryParams = {
  id?: string
} | null
export type GetVenueQueryReturnType = Venue | null

type Par = QueryOptions<GetVenueParams, GetVenueQueryParams, GetVenueQueryReturnType>

type QueOp = UseQueryOptions<
  GetVenueQueryReturnType,
  AxiosError,
  GetVenueQueryReturnType,
  [string, GetVenueQueryParams?]
>

export const makeGetVenueEndpoint = ({id}: GetVenueParams) => `venues/simple/${id}/native`

export const getVenueQuery = ({query, params, ...rest}: Par): QueOp => {
  // const navigate = useNavigate()//TODO: move somewhere, it's broken
  const {l} = useLocale()
  return {
    queryKey: ['getVenueQuery', {id: params?.id || ''}],
    cacheTime: 1000 * 60,
    ...rest,
    refetchOnWindowFocus: rest.refetchOnWindowFocus || false,
    queryFn: ({queryKey: [_, config]}) => {
      if (params?.id) {
        return API.get<GetVenueQueryParams, GetVenueQueryReturnType>(makeGetVenueEndpoint(params), {
          params: config,
          query,
        })
          .then((res) => res.data)
          .catch(() => {
            // navigate('/')
            showMessage(l('noResultsFound') as string, 'error')
            return null
          })
      }
      return new Promise((res) => res(null))
    },
  }
}
